import { useTranslation } from "react-i18next";
import { DeleteDigitalSignatureModal } from "../../components/delete-digital-signature";
import { PageLayout } from "../../components/page-layout";
import { DigitalSignatures } from "./DigitalSignatures";
import { useDigitalSignature } from "./useDigitalSignature";

export const DigitalSignatureScreen = () => {
  const {
    documents,
    onResend,
    loading,
    showDeleteModal,
    onStartDelete,
    closeDeleteModal,
    onDelete,
  } = useDigitalSignature();
  const { t } = useTranslation();
  return (
    <PageLayout title={t("DOCUMENTS.DOCUMENTS_FOR_DIGITAL_SIGNINING")} loading={loading}>
      <DigitalSignatures documents={documents} onDelete={onStartDelete} onResend={onResend} />
      <DeleteDigitalSignatureModal
        show={showDeleteModal}
        onDelete={onDelete}
        onCancel={closeDeleteModal}
      />
    </PageLayout>
  );
};
